import router from "src/router";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "src/serviceWorker";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./contexts/LaravelCookieAuthContext";
import { HelmetProvider } from "react-helmet-async";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <HelmetProvider>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </HelmetProvider>
);

serviceWorker.unregister();
